import styled, { css } from 'styled-components';
import { loadAnimation } from '@/app/components/search/styles/mixins.ts';

export const LoadersContainer = styled.div`
  width: 100%;
`;

export const Loader = styled.div<{
  elWidth?: number;
  elHeight?: number;
}>`
  background: ${({ theme }) => theme.kallisto.color.common.black[100]};
  position: relative;
  border-radius: 8px;
  clear: both;
  height: 16px;
  max-width: 100%;

  ${loadAnimation};

  ${({ elWidth }) =>
    elWidth
      ? css`
          width: ${elWidth}px;
        `
      : css`
          width: 100%;
        `};

  ${({ elHeight }) =>
    elHeight &&
    css`
      height: ${elHeight}px;
    `};
`;
